export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/financeEntryHeader.36782608.svg","height":183,"width":262,"blurWidth":0,"blurHeight":0};